module.exports = __webpack_public_path__ + "img/Nodata.680ea500.png";